import React from 'react';
import { useParams } from 'react-router-dom';

import CollaboratorsTable from '../components/tables/CollaboratorsTable';

const CompanyCollaboratorsPage: React.FC = () => {
  const { companyId } = useParams();
  return <CollaboratorsTable companyId={Number(companyId)} hideCompanyColumn />;
};

export default CompanyCollaboratorsPage;
